import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { AUTHENTICATED_ENTRY } from 'configs/AppConfig';

const PUBLIC_NO_AUTH_ROUTES = ['/chat-widget'];

const PublicRoute = () => {
  const { token } = useSelector((state) => state.auth);
  const location = useLocation();

  const isPublicNoAuthRoute = PUBLIC_NO_AUTH_ROUTES.some((path) =>
    location.pathname.startsWith(path)
  );

  if (isPublicNoAuthRoute) {
    return <Outlet />;
  }

  return token ? <Navigate to={AUTHENTICATED_ENTRY} /> : <Outlet />;
};

export default PublicRoute;